import {
    $createParagraphNode,
    $getRoot,
    $getSelection,
    $isRangeSelection,
    LexicalEditor

} from "lexical"
import {
    $convertFromMarkdownString,
} from '@lexical/markdown'
import {MARKDOWN_TRANSFORMERS} from "./makrdown/transformers";

// const debug = false
const debug = "lexicalAddTextMarkdown"


export function lexicalAddTextMarkdown(editor: LexicalEditor, markdown: string) {
    editor.update(() => {
        let selection = $getSelection();

        // If editor isn't focused / no selection -> append to end
        if (!$isRangeSelection(selection)) {
            $getRoot().selectEnd();
            selection = $getSelection();
            if (!$isRangeSelection(selection)) return;
        }

        // Create a placeholder container at the insertion point
        const container = $createParagraphNode();

        // Insert container:
        // - if selection is collapsed -> insert at caret
        // - if selection has range -> it will replace selection with container
        selection.insertNodes([container]);

        // Convert markdown INTO the container (does not touch root)
        $convertFromMarkdownString(markdown, MARKDOWN_TRANSFORMERS, container);
    });
}